import { Checkbox, Input, List, ListItem, Spinner } from '@material-tailwind/react';
import { SearchIcon } from 'lucide-react';
import React, { useState, useEffect } from 'react';
import { useGetSeats } from '../../../custom-hooks/use-seats';
import { convertToPresentableText, getOrdinal } from '../../../utils/functions';

const DesiredSeatsTab = ({ formData, handlers }) => {
  const { handleInputChange } = handlers;
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredSeats, setFilteredSeats] = useState([]);

  const { data: seats, isLoading: isSeatsLoading } = useGetSeats();

  useEffect(() => {
    if (seats) {
      const filtered = seats.filter(seat => seat.seatCode.toLowerCase().includes(searchTerm.toLowerCase()));
      setFilteredSeats(filtered);
    }
  }, [seats, searchTerm]);

  const handleSeatSelection = (seatId) => {
    const updatedSelectedSeats = formData.desiredSeats.some(s => s === seatId)
      ? formData.desiredSeats.filter(s => s !== seatId)
      : [...formData.desiredSeats, seatId];
    handleInputChange({ target: { name: 'desiredSeats', value: updatedSelectedSeats } });
  };



  return (
    <div>
      <h1>Interested Seats</h1>
      <div className="mt-2">
        <Input
          label="Search Seats"
          placeholder="Search by seat code"
          icon={<SearchIcon className="h-4 w-4" />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="h-[480px] overflow-y-auto">
        <List>
          {
            isSeatsLoading ? (
              <div className="flex justify-center items-center h-full">
                <Spinner />
              </div>
            ) : (
              filteredSeats
                .slice() // Create a copy to avoid mutating the original array
                .sort((a, b) => {
                  const availabilityA = a.availableHours - a.occupiedHours;
                  const availabilityB = b.availableHours - b.occupiedHours;
                  return availabilityB - availabilityA; // Sort by descending availability
                })
                .map((seat) => {
                  const availability = seat.availableHours - seat.occupiedHours;
                  return (
                    <ListItem
                      key={seat._id}
                      className="py-1"
                      disabled={availability === 0}
                      selected={formData.desiredSeats.some(s => s === seat._id)}
                      onClick={() => handleSeatSelection(seat._id)}>
                      <div className="flex w-full items-center">
                        <Checkbox
                          checked={formData.desiredSeats.some(s => s === seat._id)}
                          className="h-4 w-4"
                          ripple={false}
                          readOnly
                        />
                        <div className="flex justify-between items-center w-full">
                          <div className="font-thin">
                            Seat # {seat.seatCode} - Space {seat.coworking.number} ({seat.coworking.code}) <br />
                            <span className="text-xs">{seat.ratePerMonth} Per Month - {convertToPresentableText(seat.seatType)} - {convertToPresentableText(seat.deskType)} Desk</span>
                          </div>
                          <div className="font-thin text-xs text-gray-600 flex flex-col items-end">
                            <div className={`${availability === 0 ? "text-red-500" : "text-green-500"} `}>
                              {availability === 0 ? "Not Available" : `Available ${availability}h`} <br />
                            </div>
                            <div>
                              {getOrdinal(seat.coworking.floor.number)} Floor in {" "}
                              {seat.coworking.floor.building.name}, {seat.coworking.floor.building.branch.name} Branch
                            </div>
                          </div>
                        </div>
                      </div>
                    </ListItem>
                  )
                }))
          }
        </List>
      </div>
    </div>
  );
};

export default DesiredSeatsTab;

